import { useMemo } from 'react';
import { assign, setup } from 'xstate';
import {
  RegisterMachineContext,
  RegisterMachineEvents,
  RegisterMachineInputs,
  Step,
} from './types';
import { buildGuards } from './guards';
import { buildStates } from './states';
import { ACTIONS } from './actions';
import { EMPTY_OBJECT } from '../../constants';

type SetupConfig = {
  types?: {
    context?: RegisterMachineContext;
    events?: RegisterMachineEvents;
    input?: RegisterMachineInputs;
  };
  guards?: any;
  actions?: any;
};

type UseRegisterMachineProps = {
  steps: Step[];
  setupConfig?: SetupConfig;
};

export const useRegisterMachine = ({
  steps,
  setupConfig = EMPTY_OBJECT,
}: UseRegisterMachineProps) => {
  const machine = useMemo(() => {
    return setup({
      ...setupConfig,
      types: {
        ...(setupConfig?.types || {}),
        context: {} as RegisterMachineContext,
        events: {} as RegisterMachineEvents,
        input: {} as RegisterMachineInputs,
      },
      guards: { ...(setupConfig?.guards || {}), ...buildGuards() },
    }).createMachine({
      context: ({ input }) => ({
        isAuthenticated: input.isAuthenticated,
      }),
      id: 'generic-funnel',
      predictableActionArguments: true,
      initial: steps.length ? steps[0]?.uid : undefined,
      states: buildStates({ steps }),
      on: {
        [ACTIONS.AUTH_CHANGED]: {
          actions: assign(({ event }) => ({
            isAuthenticated: event.payload.isAuthenticated,
          })),
        },
      },
    });
  }, [steps, setupConfig]);

  return { machine };
};
